module.exports = "<div class=\"box\" (click)=\"newRoutine()\">\r\n    <img src=\"../assets/img/icons/shape.svg\">\r\n    {{'New Routine' | translate}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/routines/new-routines-card/new-routines-card.component.html
// module id = ./src/app/entities/routines/new-routines-card/new-routines-card.component.html
// module chunks = main